import { CURRENCY } from '@common/constants'
import { labelContentInitialData } from '@buy/data'
import { planInitialData } from '@buy/data/plan-data'
import { BuyPlanDataState } from './state'
import { BuyPlanActions, BuyPlanActionTypes } from './actions'

export const initialContentState: BuyPlanDataState = {
    contentData: {
        CurrencyCode: CURRENCY.USD,
        ContentLoaded: false,
        Locale: 'en-US',
        PlanGroupId: '',
        DefaultCountry: '',
        marketoProductName: '',
        marketoSalesBrief: '',
        marketoSalesforceCampaignId: '',
        submittoMarketo: true,
    },
    labelContent: labelContentInitialData,
    plan: planInitialData,
    productSettings: {
        productPortalUrl: '',
        favicon: '',
        logo: '',
        logoMobile: '',
        logoUrl: '',
        platformProduct: '',
        abandonmentProgram: '',
        analyticsContainerID: '',
        enablePlanCustomization: false,
        enableChatBot: false,
        adminUrl: '',
        productFamily: '',
        qualtricsProductName: '',
        theme: 'goto',
    },

    contentLoaded: false,
}

export const planDataReducer = (
    previousState: BuyPlanDataState | undefined,
    action: BuyPlanActions
): BuyPlanDataState => {
    const state = previousState || initialContentState
    switch (action.type) {
        case BuyPlanActionTypes.GET_LABEL_CONTENT: {
            return state
        }
        case BuyPlanActionTypes.SET_BUY_PLAN: {
            const { content, plan, labels, productSettings } = action.payload
            return {
                ...state,
                contentData: {
                    ...state.contentData,
                    ...content,
                },
                labelContent: { ...labels },
                plan,
                productSettings: {
                    ...productSettings,
                    theme: productSettings.theme || initialContentState.productSettings.theme,
                },
            }
        }
        case BuyPlanActionTypes.SET_CONTENT_LOADED: {
            return {
                ...state,
                contentLoaded: action.payload.loaded,
            }
        }
        case BuyPlanActionTypes.GET_COMPARE_MODAL_CONTENT: {
            return state
        }
        case BuyPlanActionTypes.SET_COUPON_DISCLAIMER: {
            return {
                ...state,
                labelContent: {
                    ...state.labelContent,
                    couponDisclaimer: action.payload.couponDisclaimer,
                },
            }
        }
        default:
            return state
    }
}
